<div
  #selectcontainer
  class="{{ width }} selectControl"
  [ngClass]="dropdownPopoverShow ? 'selectControl active' : 'selectControl'"
  tabindex="-1"
>

  @if (isInvalid && !allowEmpty) {
    <div class="error-message ls-text-b3 font-medium">
      {{ errorMessage }}
    </div>
  }

  <div class="relative ls-select-input-group" [ngClass]="label ? 'labeled' : 'unlabeled'" [formGroup]="group">
    @if (label) {
      <label id="select-listbox-label" class="ml-entLbl" for="{{ inputId }}">
        {{ label }}
      </label>
    }

    <div class="ls-select-input" (click)="toggleDropdown()">
      <input
        id="{{ inputId }}"
        type="text"
        name="filter"
        class="select relative"
        [ngClass]="class"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-placeholder="placeholder"
        [attr.aria-labelledby]="label ? 'select-listbox-label' : ''"
        [attr.aria-label]="selectlistboxlabel"
        placeholder="{{ placeholder }}"
        [(ngModel)]="filterText"
        formControlName="{{ controlName }}"
        [autocomplete]="false"
        [readOnly]="!isFiltered"
        (keyup)="filter()"
      />

      <span
        [ngClass]="{'arrow-labeled': label, 'arrow-unlabeled': !label, 'sm-arrow': selectSize === 'input-sm'}"
        [ngStyle]="{'z-index': dropdownPopoverShow ? 1000 : 0}"
      >
        <svg
          width="18px"
          height="18px"
          viewBox="0 0 18 18"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <polygon
            transform="translate(9.000000, 9.000000) rotate(180.000000) translate(-9.000000, -9.000000)"
            points="9 0 18 18 0 18"
            fill="#4F1D0C"
          />
        </svg>
      </span>
    </div>

    @if (dropdownPopoverShow) {
      <div class="shadow-lg py-1 focus:outline-hidden options {{ dropdownMode }}">
        <ul
          class="overflow-auto"
          tabindex="-1"
          role="listbox"
          aria-labelledby="select-listbox-label"
          aria-activedescendant="listbox-option-3"
          [ngClass]="dropdownPopoverShow ? 'block active' : 'hidden'"
        >
          @for (option of filteredOptions; track option) {
            <li
              class="select-none relative py-2"
              [ngClass]="{'active': this.selected?.value === option.value}"
              role="option"
              [class.disabled]="option.disabled"
              (click)="select($event, option)"
              (keyup.enter)="select($event, option)"
              tabindex="0"
            >
              <span class="font-normal block truncate">{{ option.name }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
